import { render } from "./HeroCard.vue?vue&type=template&id=503cd8ba"
import script from "./HeroCard.vue?vue&type=script&lang=js"
export * from "./HeroCard.vue?vue&type=script&lang=js"

import "./HeroCard.vue?vue&type=style&index=0&id=503cd8ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__